export default "__VITE_ASSET__DlhOvO8q__"